export default __webpack_public_path__ + "static/media/smartphone.dd8b4ee1.svg";